class FulliceProductFacts extends HTMLElement {
  #section;

  connectedCallback() {
    this.#section = this.closest('.shopify-section');
    this.#section?.addEventListener('variant:update', this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener('variant:update', this.#handleVariantUpdate);
  }

  #handleVariantUpdate = (event) => {
    if (event.detail?.data?.productId !== this.dataset.productId) return;

    const next = event.detail.data.html.querySelector(
      `fullice-product-facts[data-product-id="${this.dataset.productId}"]`
    );
    if (!next) return;

    this.replaceChildren(...Array.from(next.childNodes, (node) => node.cloneNode(true)));
  };
}

if (!customElements.get('fullice-product-facts')) {
  customElements.define('fullice-product-facts', FulliceProductFacts);
}
